import { render, staticRenderFns } from "./DropdownOption.vue?vue&type=template&id=72752f8f&shadow"
import script from "./DropdownOption.vue?vue&type=script&lang=js&shadow"
export * from "./DropdownOption.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports